<form>
    <app-input [formControl]="formGroup.controls.name"
               [placeholder]="'admin.toolMaintenancePlans.activities.modal.nameLabel' | translate"
               [showErrors]="showErrors">
    </app-input>
    <app-textarea class="description"
               [formControl]="formGroup.controls.description"
               [placeholder]="'admin.toolMaintenancePlans.activities.modal.descriptionLabel' | translate"
               [showErrors]="showErrors">
    </app-textarea>
    <app-input [formControl]="formGroup.controls.rootPath"
               [placeholder]="'admin.toolMaintenancePlans.activities.modal.rootPathLabel' | translate"
               [showErrors]="showErrors">
    </app-input>
    <div class="row">
        <app-assignation-dropdown [items]="dropdownItems"></app-assignation-dropdown>
        <app-input [formControl]="formGroup.controls.priority"
                   [placeholder]="'admin.toolMaintenancePlans.activities.modal.priorityLabel' | translate"
                   [showErrors]="showErrors"
                   [type]="'number'">
        </app-input>
    </div>
    <div class="info">
        <p>{{'admin.toolMaintenancePlans.activities.modal.priorityInfo' | translate}}</p>
    </div>
</form>

